// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}

- {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  }

body {
font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
sans-serif;
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
background-color: #f5f7fa;
}

code {
font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
monospace;
}

button {
font-family: inherit;
cursor: pointer;
}

input, textarea, select {
font-family: inherit;
}

a {
text-decoration: none;
color: inherit;
}

.loading-container {
display: flex;
flex-direction: column;
justify-content: center;
alignItems: center;
height: 100vh;
background: #f5f7fa;
}

.spinner {
width: 50px;
height: 50px;
border: 5px solid #e1e8ed;
border-top: 5px solid #667eea;
border-radius: 50%;
animation: spin 1s linear infinite;
margin-bottom: 20px;
}

.card {
transition: transform 0.3s, box-shadow 0.3s;
}

.card:hover {
transform: translateY(-5px);
box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.file-item {
transition: background 0.2s;
}

.file-item:hover {
background: #f0f3f7;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
width: 10px;
height: 10px;
}

::-webkit-scrollbar-track {
background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
background: #888;
border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
background: #555;
}

/* Utility Classes */
.container {
max-width: 1400px;
margin: 0 auto;
padding: 20px;
}

.text-center {
text-align: center;
}

.mt-1 { margin-top: 8px; }
.mt-2 { margin-top: 16px; }
.mt-3 { margin-top: 24px; }
.mt-4 { margin-top: 32px; }

.mb-1 { margin-bottom: 8px; }
.mb-2 { margin-bottom: 16px; }
.mb-3 { margin-bottom: 24px; }
.mb-4 { margin-bottom: 32px; }

.p-1 { padding: 8px; }
.p-2 { padding: 16px; }
.p-3 { padding: 24px; }
.p-4 { padding: 32px; }

.flex {
display: flex;
}

.flex-col {
flex-direction: column;
}

.items-center {
align-items: center;
}

.justify-center {
justify-content: center;
}

.justify-between {
justify-content: space-between;
}

.gap-1 { gap: 8px; }
.gap-2 { gap: 16px; }
.gap-3 { gap: 24px; }

.w-full {
width: 100%;
}

.h-full {
height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;AACA,KAAK,uBAAuB,EAAE;AAC9B,OAAO,yBAAyB,EAAE;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB;;AAEF;AACA;;UAEU;AACV,mCAAmC;AACnC,kCAAkC;AAClC,yBAAyB;AACzB;;AAEA;AACA;SACS;AACT;;AAEA;AACA,oBAAoB;AACpB,eAAe;AACf;;AAEA;AACA,oBAAoB;AACpB;;AAEA;AACA,qBAAqB;AACrB,cAAc;AACd;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB,uBAAuB;AACvB,kBAAkB;AAClB,aAAa;AACb,mBAAmB;AACnB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,yBAAyB;AACzB,6BAA6B;AAC7B,kBAAkB;AAClB,kCAAkC;AAClC,mBAAmB;AACnB;;AAEA;AACA,2CAA2C;AAC3C;;AAEA;AACA,2BAA2B;AAC3B,uCAAuC;AACvC;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;AACA,mBAAmB;AACnB;;AAEA,sBAAsB;AACtB;AACA,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA;AACA,gBAAgB;AAChB;;AAEA,oBAAoB;AACpB;AACA,iBAAiB;AACjB,cAAc;AACd,aAAa;AACb;;AAEA;AACA,kBAAkB;AAClB;;AAEA,QAAQ,eAAe,EAAE;AACzB,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,gBAAgB,EAAE;;AAE1B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;;AAE7B,OAAO,YAAY,EAAE;AACrB,OAAO,aAAa,EAAE;AACtB,OAAO,aAAa,EAAE;AACtB,OAAO,aAAa,EAAE;;AAEtB;AACA,aAAa;AACb;;AAEA;AACA,sBAAsB;AACtB;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,uBAAuB;AACvB;;AAEA;AACA,8BAA8B;AAC9B;;AAEA,SAAS,QAAQ,EAAE;AACnB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;;AAEpB;AACA,WAAW;AACX;;AAEA;AACA,YAAY;AACZ","sourcesContent":["@keyframes spin {\n0% { transform: rotate(0deg); }\n100% { transform: rotate(360deg); }\n}\n\n- {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  }\n\nbody {\nfont-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\nsans-serif;\n-webkit-font-smoothing: antialiased;\n-moz-osx-font-smoothing: grayscale;\nbackground-color: #f5f7fa;\n}\n\ncode {\nfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\nmonospace;\n}\n\nbutton {\nfont-family: inherit;\ncursor: pointer;\n}\n\ninput, textarea, select {\nfont-family: inherit;\n}\n\na {\ntext-decoration: none;\ncolor: inherit;\n}\n\n.loading-container {\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\nalignItems: center;\nheight: 100vh;\nbackground: #f5f7fa;\n}\n\n.spinner {\nwidth: 50px;\nheight: 50px;\nborder: 5px solid #e1e8ed;\nborder-top: 5px solid #667eea;\nborder-radius: 50%;\nanimation: spin 1s linear infinite;\nmargin-bottom: 20px;\n}\n\n.card {\ntransition: transform 0.3s, box-shadow 0.3s;\n}\n\n.card:hover {\ntransform: translateY(-5px);\nbox-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.file-item {\ntransition: background 0.2s;\n}\n\n.file-item:hover {\nbackground: #f0f3f7;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\nwidth: 10px;\nheight: 10px;\n}\n\n::-webkit-scrollbar-track {\nbackground: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\nbackground: #888;\nborder-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\nbackground: #555;\n}\n\n/* Utility Classes */\n.container {\nmax-width: 1400px;\nmargin: 0 auto;\npadding: 20px;\n}\n\n.text-center {\ntext-align: center;\n}\n\n.mt-1 { margin-top: 8px; }\n.mt-2 { margin-top: 16px; }\n.mt-3 { margin-top: 24px; }\n.mt-4 { margin-top: 32px; }\n\n.mb-1 { margin-bottom: 8px; }\n.mb-2 { margin-bottom: 16px; }\n.mb-3 { margin-bottom: 24px; }\n.mb-4 { margin-bottom: 32px; }\n\n.p-1 { padding: 8px; }\n.p-2 { padding: 16px; }\n.p-3 { padding: 24px; }\n.p-4 { padding: 32px; }\n\n.flex {\ndisplay: flex;\n}\n\n.flex-col {\nflex-direction: column;\n}\n\n.items-center {\nalign-items: center;\n}\n\n.justify-center {\njustify-content: center;\n}\n\n.justify-between {\njustify-content: space-between;\n}\n\n.gap-1 { gap: 8px; }\n.gap-2 { gap: 16px; }\n.gap-3 { gap: 24px; }\n\n.w-full {\nwidth: 100%;\n}\n\n.h-full {\nheight: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
